import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { TimelineRequest, TimelineResponse } from '../../models/timeline';
import { TimelineService } from '../../services/timeline.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { CustomBottomAlertComponent } from 'src/app/core/helper/components/custom-bottom-alert/custom-bottom-alert.component';
import { TimelineSaveSuccessComponent } from '../timeline-save-success/timeline-save-success.component';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import moment from 'moment';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-add-timeline',
  templateUrl: './add-timeline.component.html',
  styleUrls: ['./add-timeline.component.scss'],
})
export class AddTimelineComponent extends BaseModal implements OnInit {
  @Input() id: number;
  @Input() farmId: number;
  @Input() date: string;
  @Input() stageTypeId: number;
  @Input() cropId: number;
  @Input() timelineId: number = 0;
  @Input() currentStep;
  @Input() activeIndex: number
  @Input() dateArr: Array<any> = [];
  stageList: Array<TimelineResponse> = []
  timelinePayload: { [key: string]: TimelineRequest } = {}
  nextStep: TimelineResponse;
  isNextButtonDisable: boolean = false;
  editedList: Array<any> = [];
  showDateError: boolean = false;
  showError: boolean = false;
  constructor(private modalService: ModalService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private timelineService: TimelineService,
    private alertService: ClientAlertService,
    private dateTimeService: DateTimeService,
    private toastService: ToastService,
    private storageService: StorageService) {
    super();
    super._modalService = modalService;
  }

  dismissModal() {
    let backStagesCallback = (ev, modalId) => {
      this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
    }
    let discardCahngesCallback = (ev, modalId) => {
      this.modalService.dismissByModalId(this.id, null, "discard");
    }
    this.alertService.BottomSheetAlert({
      buttons: [
        { callback: backStagesCallback, color: "primary", fill: "solid", text: this.translateService.instant("timeline.back-to-stages") },
        { callback: discardCahngesCallback, color: "dark", fill: "clear", text: this.translateService.instant("timeline.discard-changes") }
      ],
      title: this.translateService.instant("timeline.quit-save-title"),
      description: this.translateService.instant("timeline.quit-save-desc"),
    }).then(response => {
    })
  }

  ngOnInit() { }

  ionViewDidEnter() {
    this.getStageList();
  }

  onDateChange(ev) {
    this.date = ev;
    let activeDate; let previousDate; let nextDate; let harvestDate; let sowingDate;
    if (this.activeIndex > 0 && this.activeIndex < 2) {
      activeDate = this.dateTimeService.formatDate(this.date, 'YYYY-MM-DD');
      previousDate = this.dateTimeService.formatDate(this.dateArr[this.activeIndex - 1], 'YYYY-MM-DD');
      nextDate = this.dateTimeService.formatDate(this.dateArr[this.activeIndex + 1], 'YYYY-MM-DD');
      if (this.dateTimeService.isEqual(activeDate, previousDate) || this.dateTimeService.isBefore(activeDate, previousDate)) {
        this.isNextButtonDisable = true;
        this.showDateError = true;
        this.showError = false;
      } else {
        this.isNextButtonDisable = false;
        this.showError = false;
        this.showDateError = false;
      }
    }
    else if (this.activeIndex == 2) {
      activeDate = this.date;
      sowingDate = this.dateArr[0];
      harvestDate = this.dateArr[1];
      nextDate = this.dateArr[this.activeIndex + 1];
      if (!this.dateTimeService.isBetween(activeDate, sowingDate, harvestDate) || this.dateTimeService.isBefore(nextDate, activeDate)) {
        this.showDateError = false;
        this.showError = true;
        this.isNextButtonDisable = true;
      } else {
        this.isNextButtonDisable = false;
        this.showError = false;
        this.showDateError = false;
      }
    } else if (this.activeIndex > 2) {
      activeDate = this.dateTimeService.formatDate(this.date, 'YYYY-MM-DD');
      previousDate = this.dateTimeService.formatDate(this.dateArr[this.activeIndex - 1], 'YYYY-MM-DD');
      nextDate =this.dateArr[this.activeIndex + 1] ? this.dateTimeService.formatDate(this.dateArr[this.activeIndex + 1], 'YYYY-MM-DD') : null;
      sowingDate = this.dateTimeService.formatDate(this.dateArr[0], 'YYYY-MM-DD');
      harvestDate = this.dateTimeService.formatDate(this.dateArr[1], 'YYYY-MM-DD');
      if (!this.dateTimeService.isBetween(activeDate, sowingDate, harvestDate)) {
        this.showDateError = false;
        this.showError = true;
        this.isNextButtonDisable = true;
      } else {
        if (this.dateTimeService.isEqual(activeDate, previousDate) || this.dateTimeService.isBefore(activeDate, previousDate) || (nextDate ? this.dateTimeService.isBefore(nextDate, activeDate) : false)) {
          this.isNextButtonDisable = true;
          this.showDateError = true;
          this.showError = false;
        } else {
          this.isNextButtonDisable = false;
          this.showError = false;
          this.showDateError = false;
        }
      }
    }
  }
  refresher: boolean = true;
  getStageList() {
    this.loadingService.showLoading();
    this.timelineService.getTimelineList(this.farmId, this.cropId).subscribe(e => {
      if (e.IsSuccess) {
        this.stageList = e.Data;
        let firstElem = this.stageList[0];
        let lastElem = this.stageList[this.stageList.length - 1];
        this.editedList.push(firstElem, lastElem, ...this.stageList.slice(1, -1));
        this.nextStep = this.editedList[this.activeIndex + 1];
      }
      this.loadingService.hideLoading();
    })
  }
  saveStepList: Array<any> = [];
  save() {
    this.loadingService.showLoading();
    this.timelineService.saveTimelineRequest(this.timelinePayload).subscribe(res => {
      this.loadingService.hideLoading();
      Object.keys(res).forEach(val => {
        if (res[val].Data) {
          if (!this.saveStepList.some(step => step == val)) {
            this.saveStepList.push(val);
          }
        } else {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("errors.http_request_unexpected_error"), duration: 3500, type: Message_Type.WARNING });
        }
      })
      if (this.saveStepList.length == this.editedList.length) {
        this.modalService.presentModal({
          component: CustomBottomAlertComponent,
          componentProps: {
            title: this.translateService.instant("timeline.save-changes-title"),
            description: this.translateService.instant("timeline.save-changes-desc"),
            buttonName: this.translateService.instant("filiz-home.got-it"),
            image: '../../../../../assets/images/timeline-done.svg',
            imageHeight: 155
          },
          options: ModalService.defaultOptionsTransparent
        }).then(res => {
          this.modalService.dismissByModalId(this.id, null, "date");
          this.storageService.set(StorageKeys.updated, true).then();
          this.storageService.lastFilizFarmId = null
          this.storageService.lastTrapFarmId = null
        }).catch(err => {
        });
      } else {
        let date; let stageID; let stageName; let stageList = [];
        if (this.saveStepList.length > 0) {
          this.saveStepList.forEach(elem => {
            date = elem.split("_")[0];
            stageID = elem.split("_")[1];
            stageName = this.editedList.filter(e => e.StageTypeId == stageID)[0].StageTypeName;
            stageList.push(
              {
                StageTypeName: stageName,
                Date: moment(date).format("DD MMM YYYY")
              });
          });
          this.modalService.presentModal({
            component: TimelineSaveSuccessComponent,
            componentProps: {
              data: stageList,
              description: this.translateService.instant('timeline.save-success-desc')
            },
            options: ModalService.defaultOptionsTransparent
          }).then(res => {
            this.modalService.dismissByModalId(this.id, null, "date");
            this.storageService.set(StorageKeys.updated, true).then();
            this.storageService.lastFilizFarmId = null;
            this.storageService.lastTrapFarmId = null
          }).catch(err => { })
        }

      }
    }, err => {
      this.loadingService.hideLoading();
    })
  }
  next(isContinue: boolean = true) {
    this.refresher = false;
    setTimeout(() => {
      this.refresher = true;
      this.date = this.currentStep.TimeLineLogDate ? this.currentStep.TimeLineLogDate : new Date();
    }, 100);
    this.dateArr[this.activeIndex] = this.date;
    this.timelinePayload[this.dateTimeService.formatDate(this.date, 'YYYY-MM-DD') + "_" + this.currentStep.StageTypeId] =
    {
      CropId: this.cropId,
      Date: this.date,
      Id: this.currentStep.Id == -1 ? 0 : this.currentStep.Id,
      StageTypeId: this.currentStep.StageTypeId,
      TempFarmAttId: this.farmId
    }
    if (isContinue) {
      if (this.activeIndex < this.editedList.length - 1) {
        this.activeIndex += 1;
        this.currentStep = this.editedList[this.activeIndex];
        this.nextStep = this.editedList[this.activeIndex + 1]
      }
    } else {
      this.save();
    }
  }


  previousStage() {
    this.isNextButtonDisable = false;
    this.dateArr[this.activeIndex] = null;
    this.activeIndex -= 1;
    this.currentStep = this.editedList[this.activeIndex];
    this.date = this.currentStep.TimeLineLogDate ? this.currentStep.TimeLineLogDate : new Date();
    this.nextStep = this.editedList[this.activeIndex + 1];

    //Bir önceki evreye gidildiğinde timelinepayload'ı doğru göndermek için son 2 elemanını silme işlemi
    let lastElement = Object.keys(this.timelinePayload).reverse()[0];
    delete this.timelinePayload[lastElement];
    let previousLastElem = Object.keys(this.timelinePayload).reverse()[0];
    delete this.timelinePayload[previousLastElem];
    this.refresher = false;
    setTimeout(() => {
      this.refresher = true;
    }, 100);

  }
}
